"use strict";

var ISurveyInfo;
(function (ISurveyInfo) {
  var BusinessLevel;
  (function (BusinessLevel) {
    BusinessLevel[BusinessLevel["None"] = 0] = "None";
    BusinessLevel[BusinessLevel["Critical"] = 1] = "Critical";
  })(BusinessLevel = ISurveyInfo.BusinessLevel || (ISurveyInfo.BusinessLevel = {}));
  ISurveyInfo.DOM_TYPE_TAGNAME = "Type";
  ISurveyInfo.DOM_TYPE_VALUE = "Survey";
  ISurveyInfo.DOM_ID_TAGNAME = "SurveyID";
  ISurveyInfo.JSON_SURVEY_KEYNAME = "survey";
  ISurveyInfo.JSON_ID_KEYNAME = "surveyId";
})(ISurveyInfo || (ISurveyInfo = {}));
module.exports = ISurveyInfo;